import React from 'react'
import missionImg from "../images/tuwe-values3-copy.png"
import studyImg from "../images/donation/study4.jpg"
import PovertyCycle from './PovertyCycle'
import { useEffect } from 'react'
import { useRef } from 'react'
import WhyItMatters from './WhyItMatters'
import OurTeam from './OurTeam'
import { useMediaQuery } from 'react-responsive'

const TeamSection = () => {
     const isDesktop = useMediaQuery({query: " max-width: 784px"})
     const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <>
 <div ref={servicesRef}>
<section id="join-us" className="mb-5 team section light-background" >
  {/* Section Title */}
  <div  >
  <div className="container section-title" data-aos="fade-up">
    <h2 data-reveal>Together We Believe; Together we Achieve</h2>
    <p data-reveal>Join Our Mission</p>
  </div>
  
  {/* End Section Title */}

  <div className="container together-believe">
    <div
      className="together-content d-flex"
      data-aos="fade-up"
      data-aos-delay="250"
    >
      {/* Left: Text */}
      <div className="text-half">
        <p data-reveal>
          Together we believe; together we achieve.
          <br />
          <br />
          At Tuwe Initiative, every story begins with possibility. We know what
          it feels like to start at a disadvantage, to be left behind by
          traditional funding and admissions models. Our founder, Elizabeth,
          lived it. But her journey from poverty to purpose shows what can
          happen when resilience meets opportunity.
          <br />
          <br />
          Today, Tuwe is more than her story, it’s a movement to break the cycle
          of poverty through education, digital literacy, and empowerment. And
          we can’t do it alone.
        </p>
      </div>

      {/* Right: Image */}
      <div className="image-half" data-reveal>
        <div className="together-image">
          <img
            src={missionImg}
            alt="Together We Achieve"
          />
        </div>
      </div>
    </div>
  </div>

 </div>


 
  <section className="engage section">
    <div className="container">
      <div className="section-title text-center" data-aos="fade-up">
        <span className="subtitle" data-reveal>Get Involved</span>
        <h3 data-reveal>How to Support</h3>
      </div>

      <div className={ `row gy-4 ${isDesktop ? " mt-4" : ""} `}>
        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="100"
          data-reveal
        >
          <i className="bi bi-hand-thumbs-up icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>1. Partner With Us</h4>
            <p data-reveal>
              Your gift fuels Resource Hubs, mentorship pipelines, and
              scholarships. Together we build bridges that turn potential into
              possibility.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="150"
          data-reveal
        >
          <i className="bi bi-person-badge icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>2. Sponsor a Student</h4>
            <p data-reveal>
              Ensure that no promising young person is forced out of school
              because of poverty. A small monthly gift keeps a student in
              school and gives them hope for the future.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="200"
          data-reveal
        >
          <i className="bi bi-people icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>3. Volunteer & Mentor</h4>
            <p data-reveal>
              Lend your skills, your voice, and your experience. Whether you
              are in Kenya or abroad, your mentorship can lift a student’s
              face toward the future.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="250"
          data-reveal
        >
          <i className="bi bi-megaphone icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>4. Amplify Our Story</h4>
            <p data-reveal>
              Help us change the narrative. Share Tuwe’s mission with your
              networks, every repost, every conversation, every voice matters.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

<section className="donate-bridge section">
  <div className="container">
    <div className="row align-items-center gy-4">

    

      {/* Content */}
      <div
        className=""
        data-aos="fade-left"
        data-aos-delay="150"
        data-reveal
      >
        <span className="subtitle" data-reveal>Become a Donor</span>
        <h3 data-reveal>Your Donation Is More Than a Gift</h3>

        <p data-reveal>
          Every contribution to Tuwe Initiative directly removes barriers to
          education for vulnerable youth. Your support provides access to
          mentorship, learning resources, and real pathways out of poverty.
        </p>

        <p data-reveal>
          When you give, you are not just funding programs, you are restoring
          dignity, hope, and opportunity to young people who deserve a fair
          chance to thrive.
        </p>

        <a href="/donate" className="  donation-btn" data-reveal>
          Donate Now
        </a>
      </div>

    </div>
  </div>
</section>


  <section className="support-builds section">
    <div className="container">
      <div
        className="container section-title text-center"
        data-aos="fade-up"
      >
        <br />
        <p data-reveal>What Your Support Builds</p>
        <h3 data-reveal>Impact Areas</h3>
      </div>

      <div className={ `row gy-4 ${isDesktop ? " mt-4" : ""} `}>
        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <i className="bi bi-building icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>1. Resource Hubs</h4>
            <p data-reveal>
              Equipping youth with digital skills, innovation labs, and
              vocational training.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          <i className="bi bi-journal-bookmark icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>2. Mentorship Networks</h4>
            <p data-reveal>
              Pairing youth with role models who’ve broken the cycle of
              poverty.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <i className="bi bi-people icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>3. Scholarships & Bridging Programs</h4>
            <p data-reveal>
              Giving fair academic performers a second chance at higher
              education.
            </p>
          </div>
        </div>

        <div
          className="col-lg-6 d-flex"
          data-aos="fade-up"
          data-aos-delay="250"
        >
          <i className="bi bi-globe icon" data-reveal="left"></i>
          <div className="content">
            <h4 data-reveal>4. Economic Empowerment</h4>
            <p data-reveal>
              Turning education into real income and jobs that sustain
              families.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
  <OurTeam/>

  <section className="elizabeth-note section">
    <div className="container">
      <div
        className="d-flex align-items-center gap-3 text-start"
        data-aos="fade-up"
      >
        <i className="bi bi-pencil-square icon-note" data-reveal="left"></i>
        <div className="elizabeth-note-title">
          <p data-reveal>A Note From Elizabeth</p>
          <div className="title-underline" data-reveal></div>
        </div>
      </div>

      <div
        className="note-content speech"
        data-aos="fade-up"
        data-aos-delay="150"
      >
        <i className="bi bi-quote quote-start"  ></i>
        <p data-reveal>
          If we do not stop and face in the direction of those who performed poorly or fairly academically, a grade they achieved because of poverty, then the cycle will continue. These young men and women started off at a significant disadvantage like I did. Without investment, their children will start at the same disadvantage. Tuwe exists so that no one else has to walk that journey.
        </p>

        <i className="bi bi-quote quote-end"  ></i>
      </div>
    </div>
  </section>
</div>
{/* /Team Section */}
 
    </>
  )
}

export default TeamSection